import { useCallback, useEffect } from 'react';

type ModifierKey = 'metaKey' | 'shiftKey' | 'ctrlKey' | 'altKey';

export function useHotkey(modifier: ModifierKey | null, hotkey: string, callback: () => void) {
  const onHotkey = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === hotkey) {
        const usedModifier = modifier === null ? true : Boolean(modifier && event[modifier]);
        if (usedModifier) {
          callback();
        }
      }
    },
    [modifier, hotkey, callback]
  );
  useEffect(() => {
    window.addEventListener('keydown', onHotkey);
    return () => {
      window.removeEventListener('keydown', onHotkey);
    };
  }, [onHotkey]);
}

export default useHotkey;
